var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// /~/core-js/modules/_html.js
// module id = d075
// module chunks = 0